export enum AppMenuOptions {
    None,
    Apps,
    Messages,
    Home,
    Search,
    Profile
}